import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import SignDraw from "@CubeComponents/html/signDraw";
import { useRef, useState } from "react";
import css from "./UserSignature.module.css";

function DrawSignature({ previewMode = false, defaultImage, drawSignatureCallback }) {
  const signRef = useRef();
  const [createdSignature, setCreatedSignature] = useState(defaultImage);

  const clearSignatureHandler = () => {
    signRef.current.clear();
    handleCreated(null);
  };

  const handleCreated = (data) => {
    setCreatedSignature(data);
    if (drawSignatureCallback) {
      drawSignatureCallback({ base64ImageStr: data });
    }
  };

  return (
    <div className="w-full">
      {!previewMode ? (
        <>
          <SignDraw ref={signRef} setCreatedSignature={handleCreated} />
          <div className={css.drawSignTools}>
            <ButtonComponent
              buttonType={BUTTON_TYPES.TEXT_BUTTON}
              onClick={clearSignatureHandler}
              disabled={!createdSignature}
            >
              Clear
            </ButtonComponent>
          </div>
        </>
      ) : (
        <div className={css.signaturePreviewWrapper}>
          <div className={css.signaturePreview}>
            <img src={createdSignature} />
          </div>
        </div>
      )}
    </div>
  );
}

export default DrawSignature;
